export default {
  enableContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000353","确定执行整单生效?") /* "确定执行整单生效?" */,
  delContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000354","确定要删除吗？") /* "确定要删除吗？" */,
  delSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000355","删除成功！") /* "删除成功！" */,
  operateSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000356","操作成功！") /* "操作成功！" */,
  switchObjTypeTips: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000357","切换对象类型将重置信用对象，是否还要切换？") /* "切换对象类型将重置信用对象，是否还要切换？" */,
  switchOrgTips: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000358","切换授信组织将重置信用对象，是否还要切换？") /* "切换授信组织将重置信用对象，是否还要切换？" */
};
